var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('van-nav-bar',{attrs:{"title":"发现牛股","left-text":"返回","left-arrow":""},on:{"click-left":function($event){return _vm.$router.push('/')}}}),_vm._v(" "),_c('iframe',{attrs:{"id":"external-frame","scrolling":"no","marginheight":"0","marginwidth":"0","frameborder":"0","width":"100%","height":_vm.heigh,"src":_vm.found_winner_url}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8866446e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FoundWinners.vue
// module id = null
// module chunks = 